import React from 'react';
import AuthProvider from './contexts/AuthContext';
import Loading from './components/Loading';
import { LoadingProvider } from './contexts/LoadingContext';
import { ConfirmDialogProvider } from './contexts/ConfirmDialogContext';
import { ToastProvider } from './contexts/ToastContext';
import Routes from './routes';

function App() {
  return (
    <AuthProvider>
      <LoadingProvider>
        <Loading />
          <ConfirmDialogProvider>
            <ToastProvider>
              <Routes />
            </ToastProvider>
          </ConfirmDialogProvider>
      </LoadingProvider>
    </AuthProvider>
  );
}

export default App;
